// extracted by mini-css-extract-plugin
export default {"milestoneWrapper":"milestone_milestoneWrapper__WM9tS","milestoneBackground":"milestone_milestoneBackground__DMp+F"};